module.exports = __webpack_public_path__ + "assets/img/Interiors-Australia-Landing-Page-w540.c70c87b6.webp";